import { z } from "zod";
import { createdByActorFields } from "../common/audit.js";
import { userRole } from "../users/users.schemas.js";
/**
 * Per-tenant API keys — an alternative to cookie/JWT auth for service clients
 * (robots, CI, integrations). Each key is bound to a tenant + role and is
 * presented as `Authorization: Bearer <token>` or `x-api-key: <token>`.
 *
 * The plaintext token is returned ONLY in the create response. After that the
 * caller can only see the `keyPrefix` (the first ~12 chars of the token, for
 * UI matching).
 */
export const apiKeyInfo = z.object({
    id: z.string().uuid(), // api_keys.public_id
    label: z.string(),
    role: userRole,
    userId: z.string().uuid().nullable(), // user the key acts on behalf of
    deviceId: z.string().uuid().nullable(), // capture_devices.public_id, if tied to a robot
    keyPrefix: z.string(), // non-secret display hint, e.g. "oskey_aBc1D…"
    expiresAt: z.string().datetime().nullable(),
    lastUsedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    ...createdByActorFields,
    createdBy: z.string().uuid().nullable(),
});
export const apiKeysListResponse = z.object({ items: z.array(apiKeyInfo) });
export const createApiKeyRequest = z.object({
    label: z.string().min(1).max(120),
    role: userRole,
    deviceId: z.string().uuid().nullish(),
    // Server validates this is in the future when present.
    expiresAt: z.string().datetime().nullish(),
});
/**
 * The plaintext `token` is shown to the caller exactly once at creation.
 * After this response, the server only stores a hash — losing the token means
 * generating a new one.
 */
export const apiKeyCreatedResponse = apiKeyInfo.extend({
    token: z.string(),
});
//# sourceMappingURL=api-keys.schemas.js.map